import { EProjectType } from '../../enum/project';

// The BE BCR Goal Seek clamps a diverging height to ±10000 m and then aborts (ContainerYardCalculationService.cs,
// runaway cap in the BCR Goal Seek loop): reaching it means no solution. Coupled to that BE constant until the BE
// returns an explicit no-solution flag (bead macread-fe-owx).
const BCR_GOAL_SEEK_HEIGHT_CAP_M = 10000;

export type ContainerYardResultInvalidity = 'bcrGoalSeekWithoutSolution' | 'negativeThickness' | 'reinforcedThickerThanUnreinforced';

export interface IContainerYardResultCheck {
    projectType: string | undefined;
    method: string | undefined;
    // SI heights as stored in Redux from the BE response, before any Imperial conversion
    unreinforcedHeight: number | undefined;
    reinforcedHeight: number | undefined;
}

/**
 * Single source of truth for an invalid Container Yard / Parking Deck result: Results shows the alert instead of
 * the drawings and the PDF export captures nothing. Returns null for a valid result or another project type.
 */
export const getContainerYardResultInvalidity = ({ projectType, method, unreinforcedHeight, reinforcedHeight }: IContainerYardResultCheck): ContainerYardResultInvalidity | null => {
    if (projectType !== EProjectType.container_yard && projectType !== EProjectType.parking_deck) return null;

    const heights = [unreinforcedHeight, reinforcedHeight].filter((height): height is number => typeof height === 'number');

    // Checked before the negatives: the -10000 m cap is a missing solution, not an Excel-like negative thickness
    if (projectType === EProjectType.container_yard && method === 'bcr' && heights.some(height => Math.abs(height) >= BCR_GOAL_SEEK_HEIGHT_CAP_M)) {
        return 'bcrGoalSeekWithoutSolution';
    }
    if (heights.some(height => height < 0)) return 'negativeThickness';
    if (typeof unreinforcedHeight === 'number' && typeof reinforcedHeight === 'number' && reinforcedHeight > unreinforcedHeight) {
        return 'reinforcedThickerThanUnreinforced';
    }
    return null;
};
